export default "__VITE_ASSET__DOSaYj8G__"